<template>
  <div
    v-click-outside="onClickOutside"
    class="select-box"
  >
    <div class="select-box__input">
      <input
        v-model="searchKeyword"
        :class="{'focus': isPannelVisible}"
        type="text"
        :placeholder="placeholder"
        @focus="onInputFocus"
        @input="onInputChange"
      >
      <span
        class="input__suffix"
        @click="handleClickSuffixIcon"
      >
        <i
          class="el-select__caret el-input__icon el-icon-arrow-up"
          :class="{'is-reverse': isPannelVisible}"
        />
      </span>
    </div>
    <transition
      name="el-zoom-in-top"
    >
      <div
        v-show="isPannelVisible"
        class="select-box__pannel"
      >
        <div
          v-if="!options || options.length === 0"
          class="select-box__pannel__guide"
        >
          대상 회원이 존재하지 않습니다.
        </div>
        <div
          v-else-if="foundOptions.length === 0"
          class="select-box__pannel__guide"
        >
          찾으시는 결과가 존재하지 않습니다.
        </div>
        <ul
          v-else
          class="select-box-dropdown__list"
        >
          <li
            v-for="(option, index) in foundOptions"
            :key="index"
            class="select-box-dropdown__item"
            @click="handleClickDropdownItem(option)"
          >
             <!-- Below sentence is express : name (birth(6), phonenumber(4)) 
			     ex) namename (123456, 1234)  -->
            <span style="float: left;">{{ `${option.member.name} (${option.member.birth.slice(2)}, ${option.member.phone_number.slice(-4)})` }}</span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import _ from "lodash";

export default {
	name: "TargetMemberSearchBox",
	directives: {
		clickOutside: vClickOutside.directive,
	},
	props: {
		placeholder: {
			type: String,
		},
		options: {
			type: Array,
		},
	},
	data() {
		return {
			searchKeyword: "",
			isPannelVisible: false,
			foundOptions: [],
		};
	},
	computed: {},
	watch: {
		options: {
			immediate: true,
			handler(value) {
				this.foundOptions = value;
			},
		},
	},
	methods: {
		onClickOutside(event) {
			this.searchKeyword = "";
			this.isPannelVisible = false;
		},
		onInputFocus() {
			this.isPannelVisible = true;
		},
    onInputChange($event) {
      /**
       * v-model을 사용하지 않는 이유는 https://vuejs.org/v2/guide/forms.html#Basic-Usage 2번째 경고 참조
       */
      this.searchDataByKeyword($event.target.value);
    },
		handleClickDropdownItem(option) {
			this.$emit("select", option);
			this.isPannelVisible = false;
		},
		handleClickSuffixIcon() {
			if (this.isPannelVisible) {
				this.onClickOutside();
			} else {
				this.onInputFocus();
			}
		},
		searchDataByKeyword: _.debounce(function (value) {
			if (value === "") {
				this.foundOptions = this.options;
			} else {
				this.foundOptions = this.options.filter(option => {
					let name = option.member.name.toLowerCase();
					let keyword = value.toLowerCase();

					return name.includes(keyword);
				});
			}
		}, 300),
	},
};
</script>

<style lang="scss">
.select-box {
	width: 100%;
	position: relative;
}

.select-box__input {
	position: relative;

	input {
		-webkit-appearance: none;

		border-radius: 4px;
		border: 1px solid #d3d3d3;
		width: 100%;
		height: 50px;
		padding: 0 30px 0 15px;
		box-sizing: border-box;
		font-size: inherit;

		line-height: 20px;
		letter-spacing: -0.8px;
		color: #4a4a4a;
		font-weight: 400;

		&.focus {
			border: 1px solid #4a4a4a;
		}

		&:focus {
			outline: -webkit-focus-ring-color auto 0px;
		}

		&::placeholder {
			font-size: 15px;
			color: #c7cbd2;
			letter-spacing: -0.8px;
			line-height: 22px;
		}
	}

	.input__suffix {
		position: absolute;
		height: 100%;
		right: 5px;
		top: 0;

		.el-select__caret {
			color: #c0c4cc;
			font-size: 14px;
			cursor: pointer;
			transition: transform 0.3s, -webkit-transform 0.3s;
			-webkit-transform: rotateZ(180deg);
			transform: rotateZ(180deg);

			&.is-reverse {
				-webkit-transform: rotateZ(0deg);
				transform: rotateZ(0deg);
			}
		}
	}
}

.select-box__pannel {
	z-index: 999;
	position: absolute;
	top: 50px;
	width: 100%;

	margin-top: 8px;
	max-height: 240px;
	border: solid 1px #e4e7ed;
	border-radius: 4px;
	background-color: #fff;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.select-box__pannel__guide {
	font-size: 14px;
	color: #b9b9b9;
	height: 34px;
	line-height: 34px;
	text-align: center;
	padding: 6px 0;
}

.select-box-dropdown__list {
	height: 226px;
	overflow-y: auto;
	margin: 0;
	padding: 6px 0;
	list-style: none;

	.select-box-dropdown__item {
		font-size: 14px;
		padding: 0 20px;
		box-sizing: border-box;
		cursor: pointer;
		height: 34px;
		line-height: 34px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		color: #b9b9b9;

		&:hover {
			background-color: #f2f2f2;
		}
	}
}
</style>
